import logoLockup from '../../assets/logo-lockup.png';

// Full logo lockup — framed mark + "ORGANIC / ELECTRONICS / AUDIO" wordmark, one
// asset (464×128, from Figma). Aspect ≈ 3.63:1. A fixed 30px tall at every
// breakpoint — the header must not reflow when the logo would otherwise grow.
//
// opacity-70 reproduces the `fill-opacity:0.7` the Figma export carried; drop it
// for a bolder, blacker lockup.
export function Logo() {
    return (
        <img
            src={logoLockup}
            alt="Organic Electronics Audio"
            className="h-[30px] w-auto flex-none opacity-70"
        />
    );
}

export default Logo;
